import Link from "next/link";

import { LayoutGray } from "@/components/LayoutGray";

import styles from "./AboutCompany.module.scss";

const AboutCompany = () => {
  return (
    <LayoutGray title="Об организации" isBackButton isProfileButton>
      <div className={styles.root}>
        <h4 className={styles.title}>ОБ ОРГАНИЗАЦИИ</h4>
        <p className={styles.textBlock}>
          Контакты: Фактический адрес: 123308 г. Москва, ул. проспект Маршала
          Жукова 2 к2 стр1, офис 403.
          <br />
          Электронная почта:
          <Link className={styles.link} href="mailto:cio@lookonline.ru">
            cio@lookonline.ru
          </Link>
          <br />
          Телефоны:
          <Link className={styles.link} href="tel:+79251413587">
            +79251413587
          </Link>
          <br />
          Реквизиты:ООО «Нью Лайн»ИНН 7734438295 / ОГРНИП 1207700416131.
          <br />
          Юр. адрес: 123308 г. Москва, ул. проспект Маршала Жукова 2 к2 стр1,
          офис 403.
          <br />
          Телефон: +79251413587
          <br />
        </p>
        <h4>Способы оплаты:</h4>
        <b>Банковской картой</b> <br />
        Для выбора оплаты товара с помощью банковской карты на соответствующей
        странице необходимо нажать кнопку Оплата заказа банковской картой.Оплата
        происходит через ПАО СБЕРБАНК с использованием банковских карт следующих
        платёжных систем:
        <ul className={styles.paySystemList}>
          <li>МИР</li>
          <li>VISA International</li>
          <li>Mastercard Worldwide</li>
          <li>JCB</li>
        </ul>
        Для оплаты (ввода реквизитов Вашей карты) Вы будете перенаправлены на
        платёжный шлюз ПАО СБЕРБАНК. Соединение с платёжным шлюзом и передача
        информации осуществляется в защищённом режиме с использованием протокола
        шифрования SSL. В случае если Ваш банк поддерживает технологию
        безопасного проведения интернет-платежей Verified By Visa, MasterCard
        SecureCode, MIR Accept, J-Secure, для проведения платежа также может
        потребоваться ввод специального пароля. Настоящий сайт поддерживает
        256-битное шифрование. Конфиденциальность сообщаемой персональной
        информации обеспечивается ПАО СБЕРБАНК. Введённая информация не будет
        предоставлена третьим лицам за исключением случаев, предусмотренных
        законодательством РФ. Проведение платежей по банковским картам
        осуществляется в строгом соответствии с требованиями платёжных систем
        МИР, Visa Int., MasterCard Europe Sprl, JCB. Возврат товара Срок
        возврата товара надлежащего качества составляет 7 дней с момента
        получения товара. Возврат переведённых средств, производится на ваш
        банковский счёт в течение 5-30 рабочих дней (срок зависит от банка,
        который выдал вашу банковскую карту).
      </div>
    </LayoutGray>
  );
};

export default AboutCompany;
